import { groupBy } from 'lodash-es'
import { buildGroup } from '@/components/combined-predict/components/CombinedPredictTable/utils/regroupBuilders'

const getChildrenWithSourceName = (categories) => {
  // console.log('getTaggedChildren called with categories:', categories)
  return categories.flatMap(({ children = [], ...parentData }) => {
    // console.log('Parent data:', parentData, 'Children:', children)
    return children.filter((child) => child.sourceName).map((child) => ({ child, parentData }))
  })
}

const getGroupableModelIds = (categories) => [
  ...new Set(
    getChildrenWithSourceName(categories)
      .map((child) => child?.child?.modelId || child?.parentData?.modelId)
      .filter(Boolean),
  ),
]

const regroupByProperty = (categories) => {
  const childrenWithSourceName = getChildrenWithSourceName(categories)
  // console.log('Tagged children for regrouping:', taggedChildren)

  // console.log('Grouped entries by property name:', grouped)

  const grouped = groupBy(childrenWithSourceName, (entry) => entry.child.name)
  // console.log('Grouped with lodash:', grouped)

  const ungroupedParents = categories.reduce((acc, { children = [], ...parentData }) => {
    const remaining = children.filter((child) => !child.sourceName)
    if (remaining.length) acc.push({ ...parentData, children: remaining })
    return acc
  }, [])

  // console.log('Simple Leftover parents after grouping:', leftoverParents)

  const groupNodes = Object.entries(grouped).map(([propertyName, entries]) => {
    const unit = entries.find((e) => e.child.unit)?.child?.unit

    const getLeafIds = () => {
      const children = entries.map(({ child }) => child)

      const getLeafIdsFromChildren = (children) => {
        return children.flatMap((child) => {
          return child?.children?.length ? getLeafIdsFromChildren(child.children) : child?.id
        })
      }
      return getLeafIdsFromChildren(children)
    }

    const enrichColumnsWithProps = (columns, props) =>
      columns.map((column) => ({
        ...column,
        ...props,
      }))

    const group = buildGroup(propertyName, unit)

    return {
      ...group,
      children: [
        ...entries.map(({ child, parentData }) => ({
          ...child,
          ...parentData,
          groupId: group?.id,
          description: child.description,
          parentDescription: parentData.description,
          ...(child.children?.length ? { children: child.children } : {}),
        })),
        ...(group.children?.length
          ? enrichColumnsWithProps(group.children, { groupId: group?.id, memberIds: getLeafIds() })
          : []),
      ],
    }
  })

  return [...groupNodes, ...ungroupedParents]
}

export { regroupByProperty, getGroupableModelIds }
